import { Component, Input, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CatalogMerchandisingService } from '../../../services/products/catalog-merchandising.service';

@Component({
  selector: 'app-catalog-merchandising', standalone: true, imports: [FormsModule],
  template: `
    <div class="my-3 rounded-lg border border-base-300 p-3">
      <button type="button" class="btn btn-sm btn-outline" (click)="open()" [disabled]="busy()">Customer listing sponsorship</button>
      @if (expanded()) {
        <div class="mt-3 flex flex-wrap items-end gap-4">
          <label><input type="checkbox" [(ngModel)]="sponsored" [disabled]="busy()" /> Sponsored</label>
          <label>Priority (0–100)<input class="input input-bordered block w-28" type="number" min="0" max="100" step="1" [(ngModel)]="priority" [disabled]="busy()" /></label>
          <label>Start (local time, optional)<input class="input input-bordered block" type="datetime-local" [(ngModel)]="startsAt" [disabled]="busy()" /></label>
          <label>End (local time, optional)<input class="input input-bordered block" type="datetime-local" [(ngModel)]="endsAt" [disabled]="busy()" /></label>
          <button type="button" class="btn btn-primary btn-sm" (click)="save()" [disabled]="busy()">Save sponsorship</button>
          <button type="button" class="btn btn-ghost btn-sm" (click)="expanded.set(false)" [disabled]="busy()">Close</button>
        </div>
        <p class="mt-2 text-sm">Applies only to this store and product. Recommended lists allow up to two in-stock sponsored products at the top. Explicit customer sorts do not receive paid boosts. Expired or unavailable products are not promoted.</p>
      }
      @if (error()) { <p role="alert" class="text-error mt-2">{{ error() }}</p> }
      @if (saved()) { <p role="status" class="text-success mt-2">Sponsorship saved.</p> }
    </div>`,
})
export class CatalogMerchandisingComponent {
  @Input({ required: true }) storeId!: number;
  @Input({ required: true }) productId!: number;
  private service = inject(CatalogMerchandisingService);
  expanded = signal(false);
  busy = signal(false);
  error = signal('');
  saved = signal(false);
  sponsored = false;
  priority = 0;
  startsAt = '';
  endsAt = '';

  private localDate(value: string | null) {
    if (!value) return '';
    const date = new Date(value);
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  }
  async open() {
    this.busy.set(true); this.error.set(''); this.saved.set(false);
    try {
      const value = await this.service.get(this.storeId, this.productId);
      this.sponsored = value.is_sponsored; this.priority = value.priority;
      this.startsAt = this.localDate(value.starts_at); this.endsAt = this.localDate(value.ends_at);
      this.expanded.set(true);
    } catch { this.error.set('Could not load sponsorship. Check backend deployment and try again.'); }
    finally { this.busy.set(false); }
  }
  async save() {
    this.busy.set(true); this.error.set(''); this.saved.set(false);
    try {
      await this.service.save(this.storeId, this.productId, {
        is_sponsored: this.sponsored, priority: this.priority,
        starts_at: this.startsAt ? new Date(this.startsAt).toISOString() : null,
        ends_at: this.endsAt ? new Date(this.endsAt).toISOString() : null,
      });
      this.saved.set(true);
    } catch (error) { this.error.set(error instanceof Error ? error.message : 'Could not save sponsorship.'); }
    finally { this.busy.set(false); }
  }
}
